export enum SearchFilterLanguage {
  en = 'en',
  de = 'de',
  fr = 'fr',
  nl = 'nl'
}

const searchFilterLanguageMap = {
  en: 'English',
  de: 'German',
  fr: 'French',
  nl: 'Dutch'
};

export const searchFilterLanguageToString = (
  language?: SearchFilterLanguage
): string => {
  return language ? searchFilterLanguageMap[language] : '?';
};

export type SearchFilterLanguageType = {
  [key in SearchFilterLanguage]?: string;
};
